<template>
  <div class="wrapper">
    <parallax
      class="page-header header-filter header-small"
      parallax-active="true"
      :style="{ backgroundImage: `url(${basicInfo.headerImage})` }"
    >
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center"
          >
            <h1 class="title">
              {{ basicInfo.name }}
            </h1>
            <h4>
              {{ basicInfo.descriptionShort }}
            </h4>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section section-about-description text-center pb-0">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-66 md-small-size-100 mx-auto">
              <h5 class="description">
                {{ basicInfo.descriptionLong }}
              </h5>
            </div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="md-layout-item">
          <div class="subscribe-line subscribe-line-white pb-0 pt-0">
            <div class="container">
              <div class="md-layout">
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <h3 class="title">
                    Jetzt für neue Beiträge anmelden!
                  </h3>
                  <p class="description">
                    Erhalten Sie alle Beiträge Ihres Dorfladens in Ihr Email
                    Postfach.
                  </p>
                </div>
                <div
                  class="md-layout-item md-medium-size-50 md-small-size-100 d-flex-center"
                >
                  <md-card class="md-card-form-horizontal md-card-plain">
                    <md-card-content>
                      <div class="md-layout">
                        <div
                          class="md-layout-item md-large-size-50 md-xsmall-size-100 md-small-size-70"
                        >
                          <md-field class="md-form-group">
                            <md-icon>mail</md-icon>
                            <md-input
                              v-model="subscribeEmail"
                              placeholder="Email"
                            />
                          </md-field>
                        </div>
                        <div
                          class="md-layout-item md-large-size-50 md-xsmall-size-30 md-small-size-30"
                        >
                          <md-button
                            class="md-button md-primary md-round anmelden"
                            @click="subscribe"
                          >
                            anmelden
                          </md-button>
                        </div>
                      </div>
                      <p v-if="subscribeSuccess">
                        Vielen Dank! Bitte bestätigen Sie Ihre Email durch den
                        Link, welcher Ihnen soeben zugesendet wurde
                      </p>
                      <p v-if="subscribeSuccess == false">
                        FEHLER! Leider ist ein Fehler aufgetreten, bitte
                        versuchen Sie es später erneut.
                      </p>
                    </md-card-content>
                  </md-card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="settingsListGetter[0]">
        <!-- section menu plan-->
        <div
          v-if="settingsListGetter[0].AllowMenuPlan.value"
          class="md-layout md-alignment-top-center"
        >
          <menuPlanSection :did="this.dorfladenId" />
        </div>
        <br />
        <!-- section pre order-->
        <div
          v-if="settingsListGetter[0].AllowPreOrder.value"
          class="md-layout md-alignment-top-center"
        >
          <preOrderSection :did="this.dorfladenId" />
          <br />
        </div>

        <!-- section shares-->
        <div
          v-if="settingsListGetter[0].AllowShareHolding.value"
          class="md-layout md-alignment-top-center"
        >
          <div class="md-layout-item md-size-50 md-small-size-90">
            <h3 class="title">
              Beteiligungen an Ihrem Dorfladen reservieren
            </h3>
            <p class="description">
              Sichern sie sich jetzt unverbindlich eine Beteiligung an Ihrem
              Dorfladen-Projekt.
            </p>
            <md-button
              class="md-round md-block md-primary"
              @click="signupModal = true"
            >
              <md-icon>assignment</md-icon> Beteiligungen Reservieren
            </md-button>
            <br />
            <div class="md-layout-item md-size-50 md-xsmall-size-100">
              <div class="modal modal-bg" :class="{ show: signupModal }">
                <modal
                  v-if="signupModal"
                  modal-with-card
                  type="modal-signup"
                  card-classes="md-card-signup"
                  @close="signupModal = false"
                >
                  <template slot="header">
                    <md-button
                      class="md-simple md-close md-just-icon md-round modal-default-button"
                      @click="signupModal = false"
                    >
                      <md-icon>clear</md-icon>
                    </md-button>
                    <h3 class="title text-center">
                      Jetzt unverbindlich Beteiligungen reservieren
                    </h3>
                  </template>

                  <template v-if="!shareFormMessanges.success" slot="body">
                    <div class="md-layout">
                      <div
                        slot="content-left"
                        class="md-layout-item md-size-40 md-medium-size-50 md-small-size-100 ml-auto"
                      >
                        <div
                          v-for="item in contentLeft"
                          :key="item.title"
                          class="info info-horizontal"
                        >
                          <div :class="`icon ${item.colorIcon}`">
                            <md-icon>{{ item.icon }}</md-icon>
                          </div>
                          <div class="description">
                            <h4 class="info-title">
                              {{ item.title }}
                            </h4>
                            <p class="description">
                              {{ item.description }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        slot="content-right"
                        class="md-layout-item md-size-40 md-medium-size-50 md-small-size-100 mr-auto"
                      >
                        <br />
                        <h4 class="text-center">
                          Jetzt Beteiligungen zeichnen:
                        </h4>
                        <h6 class="text-center">
                          Achtung! durch eintragen Ihrer Daten in das folgende
                          Formular wird kein Vertrag geschlossen! Es handelt
                          sich lediglich um eine Willensbekundung.
                        </h6>
                        <form>
                          <md-field class="md-form-group">
                            <md-icon>face</md-icon>
                            <label>Vorname*</label>
                            <md-input
                              v-model="shareFormValues.prename"
                              type="text"
                            />
                          </md-field>
                          <md-field class="md-form-group">
                            <md-icon>face</md-icon>
                            <label>Nachname*</label>
                            <md-input
                              v-model="shareFormValues.surname"
                              type="text"
                            />
                          </md-field>
                          <md-field class="md-form-group">
                            <md-icon>home</md-icon>
                            <label>Adresse*</label>
                            <md-input
                              v-model="shareFormValues.address"
                              type="text"
                            />
                          </md-field>
                          <md-field class="md-form-group">
                            <md-icon>phone</md-icon>
                            <label>Telefon</label>
                            <md-input
                              v-model="shareFormValues.phone"
                              type="text"
                            />
                          </md-field>
                          <md-field class="md-form-group">
                            <md-icon>email</md-icon>
                            <label>E-Mail</label>
                            <md-input
                              v-model="shareFormValues.email"
                              type="email"
                            />
                          </md-field>
                          <br />
                          <h6>
                            Ich habe Interesse, eine Beteiligung in folgender
                            Höhe zu zeichnen (Mindestbetrag €250): *
                          </h6>
                          <md-field>
                            <md-input
                              v-model="shareFormValues.shareInEuro"
                              type="number"
                            />
                            <md-icon>euro_symbol</md-icon>
                          </md-field>
                          <h6
                            v-if="shareFormMessanges.incomplete"
                            class="error-message"
                          >
                            FEHLER - Bitte überprüfen Sie die Vollständigkeit
                            Ihrer Angaben.
                          </h6>
                          <h6
                            v-if="shareFormMessanges.error"
                            class="error-message"
                          >
                            FEHLER - Leider konnten Ihre Daten nicht verarbeitet
                            werden, bitte versuchen Sie es später erneut.
                          </h6>
                          <div class="button-container justify-content-center">
                            <md-button
                              @click="submitShare()"
                              class="md-success md-round mt-3"
                            >
                              Anfrage absenden
                            </md-button>
                          </div>
                          <br />
                          <p>* diese Felder werden benötgt</p>
                        </form>
                      </div>
                    </div>
                  </template>

                  <template v-if="shareFormMessanges.success" slot="body">
                    <div class="md-layout">
                      <div
                        class="md-layout-item md-size-40 md-medium-size-90 md-small-size-100 text-center"
                      >
                        <h3>
                          Vielen Dank für Ihr Interesse, Ihre Angaben wurden
                          übermittelt.
                        </h3>
                      </div>
                      <md-button
                        class="md-round md-block md-primary"
                        @click="signupModal = false"
                      >
                        zurück
                      </md-button>
                    </div>
                  </template>
                </modal>
              </div>
            </div>
          </div>
          <br />
        </div>
      </div>
      <div class="section section-about-office pb-0">
        <div class="container">
          <div class="md-layout text-center">
            <div class="md-layout-item md-size-100 md-small-size-100 mx-auto">
              <h2 class="title">
                Aktuelle Beiträge
              </h2>
              <div v-if="messanges.length == 0">Keine Beiträge vorhanden</div>
              <div class="md-layout" v-if="!messangeError">
                <div
                  class="md-layout-item md-large-size-33 md-medium-size-50 md-small-size-100 textInCard"
                  v-for="message in messanges"
                  :key="message.id"
                >
                  <rotating-card
                    :manual-rotate-state="manualRotateState"
                    manual-rotate
                  >
                    <template slot="frontRotateCardContent">
                      <h5
                        class="card-category card-category-social text-success"
                      >
                        <i class="far fa-newspaper" /> Dorfladen
                        {{ basicInfo.name }} &#183;
                        {{ message.formattedCreatedAt }}
                      </h5>
                      <h4 class="card-title">
                        <a href="javascript:void(0)">"{{ message.heading }}"</a>
                      </h4>
                      <p class="card-description">
                        {{ message.descriptionShort }}
                      </p>
                      <router-link :to="'/message/' + message.id"
                        >Jetzt Beitrag ansehen</router-link
                      >
                    </template>
                  </rotating-card>
                </div>
              </div>
              <div class="md-layout" v-if="messangeError">
                <div
                  class="md-layout-item md-large-size-100 md-medium-size-50 md-small-size-100"
                >
                  <rotating-card
                    :manual-rotate-state="manualRotateState"
                    manual-rotate
                  >
                    <template slot="frontRotateCardContent">
                      <h5
                        class="card-category card-category-social text-success"
                      >
                        <md-icon>warning</md-icon> FEHLER
                      </h5>
                      <h4 class="card-title">
                        <a href="javascript:void(0)"
                          >Leider ist beim Laden der Nachrichten ein Fehler
                          aufgetreten</a
                        >
                      </h4>
                      <p>Bitte versuchen Sie es später erneut.</p>
                    </template>
                  </rotating-card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="md-layout md-gutter">
      <info-areas
        class="md-layout-item-medium md-medium-size-50 md-small-size-100"
        info-horizontal
        icon-color="primary"
        icon="pin_drop"
      >
        <h4 slot="title" class="info-title">
          {{ basicInfo.name }}
        </h4>
        <div slot="content" class="description">
          <p>{{ basicInfo.contact.adress }}<br /></p>
          <p>{{ basicInfo.zip }} {{ basicInfo.location }}</p>
        </div>
      </info-areas>
      <info-areas
        class="md-layout-item-medium md-medium-size-50 md-small-size-100"
        info-horizontal
        icon-color="primary"
        icon="schedule"
        v-if="openingHours.visible"
      >
        <h4 slot="title" class="info-title">
          Öffnungszeiten
        </h4>
        <div slot="content" class="description">
          <p>
            Montag: {{ openingHours.mon }} <br />
            Dienstag: {{ openingHours.tue }} <br />
            Mittwoch: {{ openingHours.wed }} <br />
            Donnerstag: {{ openingHours.thu }}<br />
            Freitag: {{ openingHours.fri }}<br />
            Samstag: {{ openingHours.sat }}<br />
            Sonntag: {{ openingHours.sun }}
          </p>
        </div>
      </info-areas>
      <info-areas
        class="md-layout-item-medium md-medium-size-50 md-small-size-100"
        info-horizontal
        icon-color="primary"
        icon="phone"
      >
        <h4 slot="title" class="info-title">
          Kontakt
        </h4>
        <div slot="content" class="description">
          <p>
            {{ basicInfo.contact.person }} <br />
            {{ basicInfo.contact.adress }}<br />
            {{ basicInfo.zip }} {{ basicInfo.location }} <br />
            Telefon: {{ basicInfo.contact.telephone }}<br />
            E-Mail: {{ basicInfo.contact.mail }}
          </p>
        </div>
      </info-areas>
    </div>
  </div>
</template>

<script>
import { InfoAreas, RotatingCard, Modal } from "@/components";
import axios from "axios";
import { mapGetters } from "vuex";
import menuPlanSection from "../components/menuPlanSection.vue";
import preOrderSection from "../components/preOrderSection.vue";
export default {
  components: {
    InfoAreas,
    RotatingCard,
    Modal,
    menuPlanSection,
    preOrderSection,
  },
  props: ["dorfladenId"],
  bodyClass: "about-us",
  data() {
    return {
      basicInfo: null,
      openingHours: null,
      messanges: [],
      manualRotateState: false,
      subscribeEmail: "",
      messangeError: false,
      subscribeSuccess: null,
      signupModal: false,
      contentLeft: [
        {
          colorIcon: "icon-primary",
          icon: "person",
          title: "Haftung",
          description:
            "Die Haftung ist auf die Einlage begrenzt (Maximaler Verlust: Höhe der Einlage).",
        },

        {
          colorIcon: "icon-primary",
          icon: "euro_symbol",
          title: "Mindestanlagebetrag",
          description:
            "Der Mindesteinlagebetrag beträgt 250 € und muss durch 50 teilbar sein.",
        },

        {
          colorIcon: "icon-primary",
          icon: "access_time",
          title: "Mindestlaufzeit",
          description:
            "Die Mindestlaufzeit während der Anlaufphase beträgt 3 Jahre.",
        },
      ],
      shareFormValues: {
        prename: "",
        surname: "",
        shareInEuro: 250,
        address: "",
        phone: "",
        email: "",
      },
      shareFormMessanges: {
        success: false,
        incomplete: false,
        error: false,
      },
    };
  },
  mounted() {
    this.init(this.dorfladenId);
  },
  watch: {
    "$route.params.dorfladenId": function(params) {
      this.init(params);
    },
  },
  computed: {
    ...mapGetters(["backendServer", "settingsListGetter"]),
  },
  methods: {
    init(dId) {
      this.loadInformationEntrys(dId);
      this.loadMessanges(dId);
      this.$store.dispatch("getSettingsList", dId);
    },
    loadInformationEntrys(dId) {
      let vm = this;
      let getUrl = this.backendServer + "informationEntry?id=" + dId;
      axios
        .get(getUrl)
        .then(function(response) {
          vm.basicInfo = response.data.basicInfo.value;
          vm.openingHours = response.data.openingHours.value;
        })
        .catch(function(e) {
          vm.$router.push({ path: "/" });
        });
    },
    loadMessanges(dId) {
      let vm = this;
      let getUrl = this.backendServer + "newsFeedEntry?id=" + dId;
      axios
        .get(getUrl)
        .then(function(response) {
          vm.messanges = response.data;
        })
        .catch(function(e) {
          vm.messangeError = true;
        });
    },
    subscribe() {
      let vm = this;
      let postUrl = this.backendServer + "subscriber";
      let value = {
        email: this.subscribeEmail,
        surname: "n.a",
        prename: "n.a",
        user: this.dorfladenId,
      };
      axios
        .post(postUrl, value)
        .then(function(response) {
          vm.subscribeSuccess = true;
        })
        .catch(function(e) {
          vm.subscribeSuccess = false;
        });
    },
    submitShare() {
      let vm = this;
      let submitData = this.shareFormValues;
      this.shareFormMessanges.incomplete = false;
      this.shareFormMessanges.error = false;
      if (
        submitData.prename == "" ||
        submitData.surname == "" ||
        submitData.address == "" ||
        submitData.shareInEuro == 0
      ) {
        this.shareFormMessanges.incomplete = true;
      } else {
        let postUrl = this.backendServer + "share";
        vm.shareFormValues.user = vm.dorfladenId;
        axios
          .post(postUrl, vm.shareFormValues)
          .then(function(response) {
            vm.shareFormMessanges.success = true;
          })
          .catch(function(e) {
            vm.shareFormMessanges.error = true;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mt-2 {
  margin-top: 1.5rem;
}
.section {
  padding: 20px 0 !important;
}
.anmelden {
  margin-top: 20px !important;
}
.textInCard {
  overflow-wrap: break-word;
}
.error-message {
  color: #d32f2f;
}
</style>
